import { BottomAction } from '@euler/app/components/BottomAction';
import { AppModal } from '@euler/app/components/modal/AppModal';
import { Typography } from '@euler/app/components/typography';
import { Input } from '@euler/components/form/Input';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FormController, useFormController } from '@euler/lib/form/controller';
import { forwardRef, memo, useImperativeHandle } from 'react';
import { View } from 'react-native';
import { Row, Section, useStyles } from './SharedForm';

export type ObdDeviceModalRef = {
  controller?: FormController<Form>;
};

type Form = {
  serialNo: string;
  name: string;
};

type Props = {
  title: string;
  visible?: boolean;
  loading?: boolean;
  onDismiss?: () => void;
  onSave?: () => void;
};

const Content = memo(
  forwardRef<ObdDeviceModalRef, Props>(({ title, loading, onSave }, ref) => {
    const { rpx } = useResponsiveContext();
    const styles = useStyles();
    const controller = useFormController<Form>({
      serialNo: {
        required: true,
        defaultValue: '',
      },
      name: {
        required: true,
        defaultValue: '',
      },
    });

    useImperativeHandle(ref, () => ({
      controller,
    }));

    const { form } = controller;

    return (
      <>
        <Typography.Label
          medium
          size={rpx(20)}
          css={`
            text-align: center;
            margin-top: ${rpx(20)}px;
          `}
        >
          {title}
        </Typography.Label>
        <Section
          title="序列号"
          titleStyle={{ marginLeft: rpx(5), marginTop: rpx(10) }}
        >
          <Row>
            <Input
              value={form.serialNo.value}
              keyboardType="ascii-capable"
              placeholder="OBD设备序列号"
              autoCapitalize="none"
              autoCorrect={false}
              placeholderTextColor={'#666'}
              errorMsg={form.serialNo.error}
              onChangeText={form.serialNo.update}
              onBlur={form.serialNo.onBlur}
              style={styles.formInput}
            />
          </Row>
        </Section>
        <Section
          title="名称"
          titleStyle={{ marginLeft: rpx(5), marginTop: rpx(10) }}
        >
          <Row>
            <Input
              value={form.name.value}
              placeholder="OBD设备名称"
              placeholderTextColor={'#666'}
              errorMsg={form.name.error}
              onChangeText={form.name.update}
              onBlur={form.name.onBlur}
              style={styles.formInput}
            />
          </Row>
        </Section>
        <View
          css={`
            padding: ${rpx(44)}px ${rpx(15)}px ${rpx(24)}px ${rpx(15)}px;
          `}
        >
          <BottomAction.Button
            loading={loading}
            disabled={loading}
            variant="primary"
            text="保存"
            onPress={onSave}
          />
        </View>
      </>
    );
  }),
);

export const ObdDeviceModal = memo(
  forwardRef<ObdDeviceModalRef, Props>(
    ({ title, visible, loading, onDismiss, onSave }, ref) => {
      return (
        <AppModal visible={visible ?? false} onDismiss={onDismiss}>
          <Content title={title} loading={loading} onSave={onSave} ref={ref} />
        </AppModal>
      );
    },
  ),
);
